import CountryList from 'country-list';

angular.module('TInv.countries', [
]).factory('countries', function () {
    var c = CountryList.getCodeList(),
        o = {};
    for (var k in c)
        o[k.toUpperCase()] = c[k];
    return o;
});
